import React from 'react';
import { Chip } from '@mui/material';
import StorefrontIcon from '@mui/icons-material/Storefront';

interface StoreChipProps {
  shopDomain?: string | null;
}

const PALETTE: { bg: string; fg: string }[] = [
  { bg: '#e3f2fd', fg: '#0d47a1' }, // blue
  { bg: '#f3e5f5', fg: '#4a148c' }, // purple
  { bg: '#e8f5e9', fg: '#1b5e20' }, // green
  { bg: '#fff3e0', fg: '#e65100' }, // orange
  { bg: '#fce4ec', fg: '#880e4f' }, // pink
  { bg: '#e0f7fa', fg: '#006064' }, // cyan
  { bg: '#f1f8e9', fg: '#33691e' }, // lime
  { bg: '#fbe9e7', fg: '#bf360c' }, // deep-orange
];

function colorFor(domain: string) {
  let hash = 0;
  for (let i = 0; i < domain.length; i++) {
    hash = (hash * 31 + domain.charCodeAt(i)) >>> 0;
  }
  return PALETTE[hash % PALETTE.length];
}

const StoreChip: React.FC<StoreChipProps> = ({ shopDomain }) => {
  if (!shopDomain) return null;
  const label = shopDomain.replace(/\.myshopify\.com$/i, '');
  const { bg, fg } = colorFor(shopDomain);

  return (
    <Chip
      size="small"
      icon={<StorefrontIcon sx={{ color: `${fg} !important`, fontSize: 16 }} />}
      label={label}
      title={shopDomain}
      sx={{
        bgcolor: bg,
        color: fg,
        fontWeight: 500,
        borderRadius: 1,
        '& .MuiChip-label': { px: 0.75 },
      }}
    />
  );
};

export default StoreChip;
